// this function is not used at run time, it's only here for types
// istanbul ignore next
function rawGetTypeOf(x) {
    return typeof x;
}
export function getRuntimeTypeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
export function isRuntimeTypeOf(input, testType) {
    const inputType = getRuntimeTypeOf(input);
    return inputType === testType;
}
export function assertRuntimeTypeOf(input, testType, inputName) {
    if (!isRuntimeTypeOf(input, testType)) {
        throw new TypeError(`'${inputName}' is of type '${getRuntimeTypeOf(input)}' but type '${testType}' was expected.`);
    }
}
